import { useEffect, useState } from 'react';
import { ReviewInvitationsCandidateItem } from 'modules/sourcing-shared/shared-steps';
import { getSourcingSharedSubjectLine } from 'modules/sourcing-shared/utils/getSourcingSharedSubjectLine';
import { CampaignCreationSharedJobInformationFormData } from 'modules/campaign-creation-shared/forms';
import {
  SourcingSharedCustomizeMessageEmailFormData,
  SourcingSharedCustomizeMessageSmsFormData
} from 'modules/sourcing-shared/forms';

type FilledSubjectItem = {
  invitationCandidateItemId: string;
  organizationName: string;
  filledSubjectLine: string | undefined;
};

type UseSourcingSharedFillSubjectLineProps = {
  invitationCandidateItem: ReviewInvitationsCandidateItem;
  customizeMessageFormData:
    | SourcingSharedCustomizeMessageEmailFormData
    | SourcingSharedCustomizeMessageSmsFormData;
  jobInformationFormData: CampaignCreationSharedJobInformationFormData;
  jobPostingUrl: string | null;
  organizationName: string;
};

export const useSourcingSharedFillSubjectLine = ({
  invitationCandidateItem,
  customizeMessageFormData,
  jobInformationFormData,
  jobPostingUrl,
  organizationName
}: UseSourcingSharedFillSubjectLineProps) => {
  const [filledSubjectItem, setFilledSubjectItem] =
    useState<FilledSubjectItem>();

  useEffect(() => {
    // If it's already matching, skip
    if (
      invitationCandidateItem.id ===
        filledSubjectItem?.invitationCandidateItemId &&
      organizationName === filledSubjectItem?.organizationName
    ) {
      return;
    }

    const filledSubjectLine = getSourcingSharedSubjectLine({
      formSubjectLine:
        'customTemplatedSubjectLine' in customizeMessageFormData
          ? customizeMessageFormData.customTemplatedSubjectLine
          : undefined,
      agentName: customizeMessageFormData.agent.name,
      candidate: invitationCandidateItem,
      jobInformationFormData,
      jobPostingUrl,
      organizationName
    });

    setFilledSubjectItem({
      invitationCandidateItemId: invitationCandidateItem.id,
      organizationName,
      filledSubjectLine
    });
  }, [invitationCandidateItem, organizationName]);

  const isSameIdentifier =
    invitationCandidateItem.id === filledSubjectItem?.invitationCandidateItemId;

  return {
    filledSubjectLine: isSameIdentifier
      ? filledSubjectItem?.filledSubjectLine
      : ''
  };
};
